module.exports = __webpack_public_path__ + "img/coursetype-Bb.6ac75be0.png";